import { render, staticRenderFns } from "./ManyCreate.vue?vue&type=template&id=3c9545de&scoped=true"
import script from "./ManyCreate.vue?vue&type=script&lang=js"
export * from "./ManyCreate.vue?vue&type=script&lang=js"
import style0 from "@/static/css/deposit/create.css?vue&type=style&index=0&id=3c9545de&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9545de",
  null
  
)

export default component.exports